import React, { useState } from 'react'
import IconMinusCircle from '../../../assets/icons/icon-minus-circle.svg'
import IconInfo from '../../../assets/icons/icon-info-blue.svg'
import { resolveUrlForArticles } from './utils/urlUtils'
import { interpolate, getCurrentUnixTimestamp } from './utils/displayUtils'
import { REQUIREMENT } from './utils/constants/levels'
import { IntercomAPI } from '@pga/react-intercom'
import {
  AdditionalRequirementsSection,
  AdditionalRequirementsHeader,
  AdditionalRequirementsTitle,
  AdditionalRequirementsIcon,
  AdditionalRequirementsTitleText,
  AdditionalRequirementsCount,
  AdditionalRequirementsBody,
  AdditionalRequirementsDescription,
  AdditionalRequirementCard,
  AdditionalRequirementHeader,
  AdditionalRequirementIcon,
  AdditionalRequirementTitle,
  AdditionalRequirementDescription,
  AdditionalRequirementContent,
  AdditionalRequirementActions,
  AdditionalRequirementTextLink,
  TextButton,
  ActionButton,
  ActionButtonText
} from './Styles/ProgressTracker.styles'

const AdditionalRequirementsList = ({ additionalRequirements }) => {
  const [isExpanded, setIsExpanded] = useState(true)

  const hasPATRequirement = additionalRequirements.some(
    req => req.id === REQUIREMENT.PLAYING_ABILITY_TEST
  )
  const requirementsCount = hasPATRequirement ? 2 : 1
  
  const unixTimestamp = getCurrentUnixTimestamp()

  return (
    <AdditionalRequirementsSection>
      <AdditionalRequirementsHeader
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <AdditionalRequirementsTitle>
          <AdditionalRequirementsIcon
            style={{
              transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)'
            }}
          />
          <AdditionalRequirementsTitleText>
            Additional Requirements
          </AdditionalRequirementsTitleText>
        </AdditionalRequirementsTitle>
        <AdditionalRequirementsCount>
          {requirementsCount}
        </AdditionalRequirementsCount>
      </AdditionalRequirementsHeader>

      {isExpanded && (
        <AdditionalRequirementsBody>
          <AdditionalRequirementsDescription>
            Additional requirements do not need to be completed in a specific level but must be completed before applying for PGA of America Membership.
          </AdditionalRequirementsDescription>

          {/* PAT Requirement - conditionally shown in list */}
          {hasPATRequirement && (
            <AdditionalRequirementCard hasWarning>
              <AdditionalRequirementHeader>
                <AdditionalRequirementIcon src={IconMinusCircle} alt="" />
                <AdditionalRequirementTitle>
                  Playing Ability Test
                </AdditionalRequirementTitle>
              </AdditionalRequirementHeader>
              <AdditionalRequirementContent>
                <AdditionalRequirementDescription>
                  Congratulations, you have received qualifying scores on your PAT. You will still need to pass the PAT in order to enroll as a PGA of America Member by the end of Level 3.
                </AdditionalRequirementDescription>
                <AdditionalRequirementActions>
                  <ActionButton 
                    as="a" 
                    href={interpolate('https://events.pga.org/search?numericFilters%5B0%5D=start_datetime_unix%3E%3D{{unixTimestamp}}&hitsPerPage=10&page=1&refinementList%5Bevent_categories%5D%5B0%5D=Playing%20Ability%20Test&configure%5BaroundRadius%5D=40225&configure%5BaroundLatLngViaIP%5D=true', { unixTimestamp })}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <ActionButtonText>Find a PAT</ActionButtonText>
                  </ActionButton>
                  <AdditionalRequirementTextLink 
                    as="a" 
                    href={resolveUrlForArticles('/membership/associate-program/path-to-membership-articles/playing-ability-test-pat')}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View Guide
                  </AdditionalRequirementTextLink>
                </AdditionalRequirementActions>
              </AdditionalRequirementContent>
            </AdditionalRequirementCard>
          )}

          {/* Work Experience Credits - always shown in list */}
          <AdditionalRequirementCard>
            <AdditionalRequirementHeader>
              <AdditionalRequirementIcon src={IconInfo} />
              <AdditionalRequirementTitle>
                Track Your Work Experience Credits
              </AdditionalRequirementTitle>
            </AdditionalRequirementHeader>
            <AdditionalRequirementContent>
              <AdditionalRequirementDescription>
                To be eligible for PGA of America Membership, Associates must earn a total of 28 Work Experience Credits. It is your responsibility to track your credits and submit proof of completion before you take your final exam. To check your current credit total, please contact{' '}
                <TextButton onClick={() => IntercomAPI('show')}>
                  Membership Services
                </TextButton>
              </AdditionalRequirementDescription>
              <AdditionalRequirementActions>
                <AdditionalRequirementTextLink 
                  as="a" 
                  href={resolveUrlForArticles('/membership/associate-program/path-to-membership-articles/work-experience-credits')} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Learn More
                </AdditionalRequirementTextLink>
              </AdditionalRequirementActions>
            </AdditionalRequirementContent>
          </AdditionalRequirementCard>
        </AdditionalRequirementsBody>
      )}
    </AdditionalRequirementsSection>
  )
}

export default AdditionalRequirementsList
